import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TextareaModule } from 'primeng/textarea';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { TextBoxCustomization } from './textbox-edit';

@Component({
  selector: 'lib-textbox-compiling',
  imports: [
    ReactiveFormsModule,
    TextareaModule,
    DecimalPipe,
    CdkTextareaAutosize,
  ],
  template: `
    @let widget = widgetService.widget();
    @let formControl = widgetService.formControl();
    @if (widget && formControl) {
      <div class="flex w-full flex-col gap-2">
        <label for="data" class="whitespace-pre-line text-justify"
          >{{ widget.customization.description }} (max
          {{ widgetService.maxPoints() | number: '1.0-1' }}
          pt)</label
        >
        <div class="w-full">
          <textarea
            id="data"
            pTextarea
            [formControl]="formControl"
            cdkTextareaAutosize
            cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="20"
            class="w-full bg-white"
          ></textarea>
        </div>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class TextBoxCompilingComponent {
  protected widgetService = inject(
    CompilingWidgetService<TextBoxCustomization>,
  );
}
